export const US_MAINLAND_CODE = 'US';
export const US_TERRITORY_CODES = ['PR', 'VI', 'GU', 'MP', 'AS'];

export function getCountryCode(country) {
  if (!country) {
    return US_MAINLAND_CODE;
  }
  return String(country.short_name || country.code || US_MAINLAND_CODE).toUpperCase();
}

export function isUsMainland(country) {
  return getCountryCode(country) === US_MAINLAND_CODE;
}

export function isUsTerritory(country) {
  return US_TERRITORY_CODES.includes(getCountryCode(country));
}

export function filterStatesByCountry(states, country) {
  if (!country?.id || !Array.isArray(states)) {
    return [];
  }
  return states.filter((state) => Number(state.country_id) === Number(country.id));
}

export function requiresStateDropdown(country, statesForCountry = []) {
  return statesForCountry.length > 0;
}

export function requiresStateProvinceText(country, statesForCountry = []) {
  if (!country?.id || statesForCountry.length > 0) {
    return false;
  }
  return !isUsMainland(country) && !isUsTerritory(country);
}

export function getPostalCodeLabel(country, statesForCountry = []) {
  return requiresStateProvinceText(country, statesForCountry) ? 'Zip / Postal Code' : 'Zip Code';
}

export function findDefaultUsCountry(countries = []) {
  return (
    countries.find((country) => getCountryCode(country) === US_MAINLAND_CODE)
    || countries.find((country) => Number(country.id) === 225)
    || null
  );
}
